import React, {useState, useEffect} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
 

const BulkbroadcastEdit = ()=>{
     const [message, setMessage ] = useState('');
     const [phonebook, setPhonebook ] = useState('');
     const [broadcasttime, setBroadcasttime ] = useState('');
    const [redirect, setRedirect] = useState(false);


    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`bulkbroadcast/${id}`);
                 setMessage(data.message);
                 setPhonebook(data.phonebook);
                 setBroadcasttime(data.broadcasttime);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`bulkbroadcast/${id}`, {
            message,
            phonebook,
            broadcasttime,
        });
        console.log(data);
        setRedirect(true);
    };
  
    if(redirect){
         return <Navigate to={'/bulkbroadcast'} />
    }
    return (
        <Wrapper pageTitle={'Edit Bulkbroadcast'}>
            <InnerNav createLink={'/bulkbroadcastCreate'} listLink={'/bulkbroadcast'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Message </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Message" value={message}
                        onChange = {e => setMessage(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Phonebook </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Phonebook" value={phonebook}
                        onChange = {e => setPhonebook(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Broadcasttime </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Broadcasttime" value={broadcasttime}
                        onChange = {e => setBroadcasttime(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default BulkbroadcastEdit;